// Inline SVG icons for coaching controls (never glyphs or emoji: iOS renders those as emoji). Sized by font-size.
import { PathIcon } from '../../ui/Icon.tsx';

const PATHS = {
  listen: ['M3 14v-2a9 9 0 0 1 18 0v2', 'M21 16a2 2 0 0 1-2 2h-1v-6h1a2 2 0 0 1 2 2z', 'M3 16a2 2 0 0 0 2 2h1v-6H5a2 2 0 0 0-2 2z'],
  whisper: ['M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3z', 'M19 11a7 7 0 0 1-14 0', 'M12 18v3'],
  stop: ['M7 7h10v10H7z'],
  answer: ['M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z'],
  decline: ['M18 6 6 18', 'M6 6l12 12'],
  mic: ['M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3z', 'M19 11a7 7 0 0 1-14 0'],
  micOff: ['M3 3l18 18', 'M9 9v3a3 3 0 0 0 5.1 2.1', 'M15 9.3V6a3 3 0 0 0-5.9-.8', 'M19 11a7 7 0 0 1-1.2 3.9', 'M5 11a7 7 0 0 0 10.6 6'],
  back: ['M15 18l-6-6 6-6'],
} as const;
export type CoachIconName = keyof typeof PATHS;

export function CoachIcon({ name }: { name: CoachIconName }) {
  return <PathIcon paths={PATHS[name]} className="coach-icon" />;
}
